












import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlayBackInfo } from '../../core/utils';

@Component
export default class CardPlayBackInfo extends Vue {
    @Prop() id: string;
    @Prop() info: PlayBackInfo;

    get missingSpeed(): boolean {
        return !this.info || !this.info.speed || this.info.speed === '---';
    }

    get missingDescription(): boolean {
        return !this.info || !this.info.description || this.info.description === '---';
    }

    get emptyInfo(): boolean {
        return this.missingSpeed && this.missingDescription;
    }
}
